// extracted by mini-css-extract-plugin
module.exports = {"page":"video-preview_page__21k4b","pageContent":"video-preview_pageContent__MNQpN","main":"video-preview_main__2CKA-","mainContent":"video-preview_mainContent__3yqp4"};